import React, { useState, useEffect } from 'react';
import facilityService from '../services/facilityService';
import FacilityForm from '../components/FacilityForm';
import './FacilitiesPage.css';

const FacilitiesPage = () => {
  const [facilities, setFacilities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [editingFacility, setEditingFacility] = useState(null);

  useEffect(() => {
    loadFacilities();
  }, []);

  const loadFacilities = async () => {
    try {
      setLoading(true);
      const data = await facilityService.getAllFacilities();
      setFacilities(data);
      setError('');
    } catch (error) {
      setError('Fehler beim Laden der Anlagen');
      console.error('Error loading facilities:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCreate = () => {
    setEditingFacility(null);
    setShowForm(true);
  };

  const handleEdit = (facility) => {
    setEditingFacility(facility);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Möchten Sie diese Anlage wirklich löschen?')) {
      try {
        await facilityService.deleteFacility(id);
        await loadFacilities();
      } catch (error) {
        setError('Fehler beim Löschen der Anlage');
        console.error('Error deleting facility:', error);
      }
    }
  };

  const handleFormSubmit = async (facilityData) => {
    try {
      if (editingFacility) {
        await facilityService.updateFacility(editingFacility.id, facilityData);
      } else {
        await facilityService.createFacility(facilityData);
      }
      setShowForm(false);
      await loadFacilities();
    } catch (error) {
      setError('Fehler beim Speichern der Anlage');
      console.error('Error saving facility:', error);
    }
  };

  const handleFormCancel = () => {
    setShowForm(false);
    setEditingFacility(null);
  };

  if (loading) {
    return <div className="loading">Lade Anlagen...</div>;
  }

  return (
    <div className="facilities-page">
      <div className="page-header">
        <h1>Anlagenverwaltung</h1>
        <button onClick={handleCreate} className="btn btn-primary">
          Neue Anlage
        </button>
      </div>

      {error && <div className="error-message">{error}</div>}

      {showForm && (
        <FacilityForm
          facility={editingFacility}
          onSubmit={handleFormSubmit}
          onCancel={handleFormCancel}
        />
      )}

      <div className="facilities-table">
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th>Strom+Wasser-Pauschale</th>
              <th>Status</th>
              <th>Aktionen</th>
            </tr>
          </thead>
          <tbody>
            {facilities.length === 0 ? (
              <tr>
                <td colSpan="4" className="no-data">
                  Keine Anlagen vorhanden
                </td>
              </tr>
            ) : (
              facilities.map((facility) => (
                <tr key={facility.id}>
                  <td>{facility.name}</td>
                  <td>
                    {(facility.utility_allowance || 0).toLocaleString('de-DE', { 
                      style: 'currency', 
                      currency: 'EUR' 
                    })}
                  </td>
                  <td>
                    <span className={`status ${facility.active ? 'active' : 'inactive'}`}>
                      {facility.active ? 'Aktiv' : 'Inaktiv'}
                    </span>
                  </td>
                  <td className="actions">
                    <button
                      onClick={() => handleEdit(facility)}
                      className="btn btn-small"
                    >
                      Bearbeiten
                    </button>
                    <button
                      onClick={() => handleDelete(facility.id)}
                      className="btn btn-small btn-danger"
                    >
                      Löschen
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default FacilitiesPage;
